// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: uICjAYNdoB

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import Source from "../../Source"; // plasmic-import: U1WSll_dgG/component

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicSeeAllSourcePanel.module.css"; // plasmic-import: uICjAYNdoB/css

import IconarrowIosLeft11Icon from "./icons/PlasmicIcon__IconarrowIosLeft11"; // plasmic-import: zfZve7eCfw/icon

createPlasmicElementProxy;

export type PlasmicSeeAllSourcePanel__VariantMembers = {};
export type PlasmicSeeAllSourcePanel__VariantsArgs = {};
type VariantPropType = keyof PlasmicSeeAllSourcePanel__VariantsArgs;
export const PlasmicSeeAllSourcePanel__VariantProps =
  new Array<VariantPropType>();

export type PlasmicSeeAllSourcePanel__ArgsType = {
  sourcesSlot?: React.ReactNode;
};
type ArgPropType = keyof PlasmicSeeAllSourcePanel__ArgsType;
export const PlasmicSeeAllSourcePanel__ArgProps = new Array<ArgPropType>(
  "sourcesSlot"
);

export type PlasmicSeeAllSourcePanel__OverridesType = {
  root?: p.Flex<"div">;
  container?: p.Flex<"div">;
  sources?: p.Flex<"div">;
  arrow?: p.Flex<"div">;
  svg?: p.Flex<"svg">;
};

export interface DefaultSeeAllSourcePanelProps {
  sourcesSlot?: React.ReactNode;
  className?: string;
}

const $$ = {};

function PlasmicSeeAllSourcePanel__RenderFunc(props: {
  variants: PlasmicSeeAllSourcePanel__VariantsArgs;
  args: PlasmicSeeAllSourcePanel__ArgsType;
  overrides: PlasmicSeeAllSourcePanel__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root
      )}
    >
      <p.Stack
        as={"div"}
        data-plasmic-name={"container"}
        data-plasmic-override={overrides.container}
        hasGap={true}
        className={classNames(projectcss.all, sty.container)}
      >
        <p.Stack
          as={"div"}
          data-plasmic-name={"sources"}
          data-plasmic-override={overrides.sources}
          hasGap={true}
          className={classNames(projectcss.all, sty.sources)}
        >
          {p.renderPlasmicSlot({
            defaultContents: (
              <React.Fragment>
                <Source
                  baseVariant={"added"}
                  className={classNames("__wab_instance", sty.source___90QqF)}
                  hideHandle={true}
                />

                <Source
                  baseVariant={"added"}
                  className={classNames("__wab_instance", sty.source__pXtRg)}
                  hideHandle={true}
                  sourceDescription={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__d9Izm
                      )}
                    >
                      {
                        "I love @crystale & our 3 girls. Used to invest in startups. Had fun on @ABCSharkTank. Working hard to unf**k the planet."
                      }
                    </div>
                  }
                  sourceHandle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__yyEh0
                      )}
                    >
                      {"@sacca"}
                    </div>
                  }
                  sourceTitle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__nLm2B
                      )}
                    >
                      {"Chris Sacca"}
                    </div>
                  }
                />

                <Source
                  baseVariant={"added"}
                  className={classNames("__wab_instance", sty.source__hcw9J)}
                  hideHandle={true}
                  sourceDescription={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text___4YS6P
                      )}
                    >
                      {
                        "I love @crystale & our 3 girls. Used to invest in startups. Had fun on @ABCSharkTank. Working hard to unf**k the planet."
                      }
                    </div>
                  }
                  sourceHandle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__pNnRx
                      )}
                    >
                      {"@sacca"}
                    </div>
                  }
                  sourceTitle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__zY7G
                      )}
                    >
                      {"Chris Sacca"}
                    </div>
                  }
                />

                <Source
                  baseVariant={"adjustAttention"}
                  className={classNames("__wab_instance", sty.source___5YDVi)}
                  hideHandle={true}
                  sourceDescription={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__kkf4H
                      )}
                    >
                      {
                        "I love @crystale & our 3 girls. Used to invest in startups. Had fun on @ABCSharkTank. Working hard to unf**k the planet."
                      }
                    </div>
                  }
                  sourceHandle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__alE7
                      )}
                    >
                      {"@sacca"}
                    </div>
                  }
                  sourceTitle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__o6Mf5
                      )}
                    >
                      {"Chris Sacca"}
                    </div>
                  }
                />

                <Source
                  baseVariant={"added"}
                  className={classNames("__wab_instance", sty.source__tpt7S)}
                  hideHandle={true}
                  sourceDescription={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__imzhv
                      )}
                    >
                      {
                        "I love @crystale & our 3 girls. Used to invest in startups. Had fun on @ABCSharkTank. Working hard to unf**k the planet."
                      }
                    </div>
                  }
                  sourceHandle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__urhiv
                      )}
                    >
                      {"@sacca"}
                    </div>
                  }
                  sourceTitle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__xFaFs
                      )}
                    >
                      {"Chris Sacca"}
                    </div>
                  }
                />

                <Source
                  baseVariant={"added"}
                  className={classNames("__wab_instance", sty.source__wb11G)}
                  hideHandle={true}
                  sourceDescription={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__i3JVz
                      )}
                    >
                      {
                        "I love @crystale & our 3 girls. Used to invest in startups. Had fun on @ABCSharkTank. Working hard to unf**k the planet."
                      }
                    </div>
                  }
                  sourceHandle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__x8MeA
                      )}
                    >
                      {"@sacca"}
                    </div>
                  }
                  sourceTitle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__poh69
                      )}
                    >
                      {"Chris Sacca"}
                    </div>
                  }
                />

                <Source
                  baseVariant={"added"}
                  className={classNames("__wab_instance", sty.source__syvra)}
                  hideHandle={true}
                  sourceDescription={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__f610R
                      )}
                    >
                      {
                        "I love @crystale & our 3 girls. Used to invest in startups. Had fun on @ABCSharkTank. Working hard to unf**k the planet."
                      }
                    </div>
                  }
                  sourceHandle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__r8Jnl
                      )}
                    >
                      {"@sacca"}
                    </div>
                  }
                  sourceTitle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__wyaR5
                      )}
                    >
                      {"Chris Sacca"}
                    </div>
                  }
                />

                <Source
                  baseVariant={"added"}
                  className={classNames("__wab_instance", sty.source__isCg)}
                  hideHandle={true}
                  sourceDescription={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text___6SzCi
                      )}
                    >
                      {
                        "I love @crystale & our 3 girls. Used to invest in startups. Had fun on @ABCSharkTank. Working hard to unf**k the planet."
                      }
                    </div>
                  }
                  sourceHandle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__zgXlR
                      )}
                    >
                      {"@sacca"}
                    </div>
                  }
                  sourceTitle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__njo4N
                      )}
                    >
                      {"Chris Sacca"}
                    </div>
                  }
                />

                <Source
                  baseVariant={"added"}
                  className={classNames("__wab_instance", sty.source__oh0Dx)}
                  hideHandle={true}
                  sourceDescription={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__z3Xw8
                      )}
                    >
                      {
                        "I love @crystale & our 3 girls. Used to invest in startups. Had fun on @ABCSharkTank. Working hard to unf**k the planet."
                      }
                    </div>
                  }
                  sourceHandle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__rqUa
                      )}
                    >
                      {"@sacca"}
                    </div>
                  }
                  sourceTitle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__unnrw
                      )}
                    >
                      {"Chris Sacca"}
                    </div>
                  }
                />

                <Source
                  baseVariant={"added"}
                  className={classNames("__wab_instance", sty.source__pfGba)}
                  hideHandle={true}
                  sourceDescription={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__mg8Bc
                      )}
                    >
                      {
                        "I love @crystale & our 3 girls. Used to invest in startups. Had fun on @ABCSharkTank. Working hard to unf**k the planet."
                      }
                    </div>
                  }
                  sourceHandle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__kUIb
                      )}
                    >
                      {"@sacca"}
                    </div>
                  }
                  sourceTitle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__xtkO2
                      )}
                    >
                      {"Chris Sacca"}
                    </div>
                  }
                />

                <Source
                  baseVariant={"added"}
                  className={classNames("__wab_instance", sty.source__gQlwa)}
                  hideHandle={true}
                  sourceDescription={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__kcBgj
                      )}
                    >
                      {
                        "I love @crystale & our 3 girls. Used to invest in startups. Had fun on @ABCSharkTank. Working hard to unf**k the planet."
                      }
                    </div>
                  }
                  sourceHandle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__uUbAl
                      )}
                    >
                      {"@sacca"}
                    </div>
                  }
                  sourceTitle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text___3JOge
                      )}
                    >
                      {"Chris Sacca"}
                    </div>
                  }
                />

                <Source
                  baseVariant={"added"}
                  className={classNames("__wab_instance", sty.source__qEsRv)}
                  hideHandle={true}
                  sourceDescription={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__rqLtk
                      )}
                    >
                      {
                        "I love @crystale & our 3 girls. Used to invest in startups. Had fun on @ABCSharkTank. Working hard to unf**k the planet."
                      }
                    </div>
                  }
                  sourceHandle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__e05Wc
                      )}
                    >
                      {"@sacca"}
                    </div>
                  }
                  sourceTitle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__h97Qr
                      )}
                    >
                      {"Chris Sacca"}
                    </div>
                  }
                />

                <Source
                  baseVariant={"added"}
                  className={classNames("__wab_instance", sty.source__aekbZ)}
                  hideHandle={true}
                  sourceDescription={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text___5J8Lz
                      )}
                    >
                      {
                        "I love @crystale & our 3 girls. Used to invest in startups. Had fun on @ABCSharkTank. Working hard to unf**k the planet."
                      }
                    </div>
                  }
                  sourceHandle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__dHarU
                      )}
                    >
                      {"@sacca"}
                    </div>
                  }
                  sourceTitle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text___276Iu
                      )}
                    >
                      {"Chris Sacca"}
                    </div>
                  }
                />

                <Source
                  baseVariant={"added"}
                  className={classNames("__wab_instance", sty.source__oSajW)}
                  hideHandle={true}
                  sourceDescription={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__weTq
                      )}
                    >
                      {
                        "I love @crystale & our 3 girls. Used to invest in startups. Had fun on @ABCSharkTank. Working hard to unf**k the planet."
                      }
                    </div>
                  }
                  sourceHandle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text___8NdeH
                      )}
                    >
                      {"@sacca"}
                    </div>
                  }
                  sourceTitle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__fCv8
                      )}
                    >
                      {"Chris Sacca"}
                    </div>
                  }
                />

                <Source
                  baseVariant={"added"}
                  className={classNames("__wab_instance", sty.source__mrPh)}
                  hideHandle={true}
                  sourceDescription={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text___2SVnC
                      )}
                    >
                      {
                        "I love @crystale & our 3 girls. Used to invest in startups. Had fun on @ABCSharkTank. Working hard to unf**k the planet."
                      }
                    </div>
                  }
                  sourceHandle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__sr75D
                      )}
                    >
                      {"@sacca"}
                    </div>
                  }
                  sourceTitle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__eEb9
                      )}
                    >
                      {"Chris Sacca"}
                    </div>
                  }
                />

                <Source
                  baseVariant={"added"}
                  className={classNames("__wab_instance", sty.source___0Xcg5)}
                  hideHandle={true}
                  sourceDescription={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__moTnW
                      )}
                    >
                      {
                        "I love @crystale & our 3 girls. Used to invest in startups. Had fun on @ABCSharkTank. Working hard to unf**k the planet."
                      }
                    </div>
                  }
                  sourceHandle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__wjBRn
                      )}
                    >
                      {"@sacca"}
                    </div>
                  }
                  sourceTitle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__xamYg
                      )}
                    >
                      {"Chris Sacca"}
                    </div>
                  }
                />

                <Source
                  baseVariant={"added"}
                  className={classNames("__wab_instance", sty.source__a8Ih)}
                  hideHandle={true}
                  sourceDescription={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__o7F0B
                      )}
                    >
                      {
                        "I love @crystale & our 3 girls. Used to invest in startups. Had fun on @ABCSharkTank. Working hard to unf**k the planet."
                      }
                    </div>
                  }
                  sourceHandle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__xLb0H
                      )}
                    >
                      {"@sacca"}
                    </div>
                  }
                  sourceTitle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__ak4Km
                      )}
                    >
                      {"Chris Sacca"}
                    </div>
                  }
                />

                <Source
                  baseVariant={"added"}
                  className={classNames("__wab_instance", sty.source__cCo18)}
                  hideHandle={true}
                  sourceDescription={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__hsTye
                      )}
                    >
                      {
                        "I love @crystale & our 3 girls. Used to invest in startups. Had fun on @ABCSharkTank. Working hard to unf**k the planet."
                      }
                    </div>
                  }
                  sourceHandle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__bPp0
                      )}
                    >
                      {"@sacca"}
                    </div>
                  }
                  sourceTitle={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__zco6X
                      )}
                    >
                      {"Chris Sacca"}
                    </div>
                  }
                />
              </React.Fragment>
            ),
            value: args.sourcesSlot
          })}
        </p.Stack>
        <div
          data-plasmic-name={"arrow"}
          data-plasmic-override={overrides.arrow}
          className={classNames(projectcss.all, sty.arrow)}
        >
          <IconarrowIosLeft11Icon
            data-plasmic-name={"svg"}
            data-plasmic-override={overrides.svg}
            className={classNames(projectcss.all, sty.svg)}
            role={"img"}
          />
        </div>
      </p.Stack>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "container", "sources", "arrow", "svg"],
  container: ["container", "sources", "arrow", "svg"],
  sources: ["sources"],
  arrow: ["arrow", "svg"],
  svg: ["svg"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  container: "div";
  sources: "div";
  arrow: "div";
  svg: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicSeeAllSourcePanel__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicSeeAllSourcePanel__VariantsArgs;
    args?: PlasmicSeeAllSourcePanel__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicSeeAllSourcePanel__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicSeeAllSourcePanel__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSeeAllSourcePanel__ArgProps,
          internalVariantPropNames: PlasmicSeeAllSourcePanel__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSeeAllSourcePanel__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSeeAllSourcePanel";
  } else {
    func.displayName = `PlasmicSeeAllSourcePanel.${nodeName}`;
  }
  return func;
}

export const PlasmicSeeAllSourcePanel = Object.assign(
  // Top-level PlasmicSeeAllSourcePanel renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    container: makeNodeComponent("container"),
    sources: makeNodeComponent("sources"),
    arrow: makeNodeComponent("arrow"),
    svg: makeNodeComponent("svg"),

    // Metadata about props expected for PlasmicSeeAllSourcePanel
    internalVariantProps: PlasmicSeeAllSourcePanel__VariantProps,
    internalArgProps: PlasmicSeeAllSourcePanel__ArgProps
  }
);

export default PlasmicSeeAllSourcePanel;
/* prettier-ignore-end */
